<template>
  <b-container fluid
               class="px-0">
    <b-row class="mx-0"
           align-h="between"
           align-v="center">
      <b-col cols="auto">
        <slot>
          <div class="esg-title">{{ title }}</div>
        </slot>
      </b-col>
      <b-col class="actions">
        <slot name="actions"></slot>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
    },
  },
}
</script>

<style scoped>
.esg-title {
  white-space: nowrap;
  font-size: 1.25rem;
  font-weight: bold;
  font-family: NanumGothic;
  padding: 1vh 0;
  color: #444;
}

.actions {
  width: auto;
  display: flex;
  justify-content: flex-end;
  gap: .75rem;
}

.actions > * {
  max-width: fit-content;
}
</style>